var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLog(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(3.86 3.088)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FF5A85",
    d: "M20.626 16.427c-1.307-1.307-2.863-2.275-4.56-2.86 1.818-1.252 3.012-3.348 3.012-5.717 0-3.826-3.112-6.938-6.938-6.938-3.825 0-6.937 3.112-6.937 6.938 0 2.37 1.194 4.465 3.012 5.717-1.697.585-3.253 1.553-4.56 2.86C1.39 18.694.14 21.707.14 24.912h1.875c0-5.583 4.542-10.125 10.125-10.125s10.125 4.542 10.125 10.125h1.875c0-3.205-1.248-6.218-3.514-8.485zm-8.486-3.515c-2.791 0-5.062-2.27-5.062-5.062 0-2.792 2.27-5.063 5.062-5.063 2.792 0 5.063 2.271 5.063 5.063 0 2.791-2.271 5.062-5.063 5.062z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLog);
export default __webpack_public_path__ + "static/media/log.4a7cdcc6cefb82d712f1ebaf32dba3b0.svg";
export { ForwardRef as ReactComponent };